/// <amd-module name="Core/Medius.Core.Web/Scripts/components/emailStatusTab/common/emailStatusIcon"/>
import * as React from 'react';
import {
    IconStatusCheckCircleFill,
    IconStatusCheckCircleRegular,
    IconStatusQuestionFill,
    IconStatusXCircleFill,
    IconStatusXCircleRegular,
    IconWithTooltip,
} from '@medius/ui-controls';
import { translate } from 'Core/Medius.Core.Web/Scripts/lib/globalization';
import { getEmailStatusTranslationKey } from './emailStatusUtils';
import { EMAIL_STATUSES, EmailStatus } from '../models/emailEntryDto';

export interface EmailStatusIconProps {
    status: EmailStatus;
    tooltip?: string; // Make tooltip optional since we can generate it from status
}

export const EmailStatusIcon = ({ status, tooltip }: EmailStatusIconProps): React.ReactElement => {
    // Use provided tooltip or generate one from status translation
    const actualTooltip = tooltip || translate(getEmailStatusTranslationKey(status));
    const baseId = 'email-status-icon';
    console.log('Rendering EmailStatusIcon with status:', status, 'and tooltip:', actualTooltip);
    switch (status) {
        case EMAIL_STATUSES.Green:
            return (
                <IconWithTooltip
                    icon={<IconStatusCheckCircleFill color="ok" />}
                    text={actualTooltip}
                    data-testid={`${baseId}delivered-icon`}
                />
            );
        case EMAIL_STATUSES.HollowGreen:
            return (
                <IconWithTooltip
                    icon={<IconStatusCheckCircleRegular color="ok" />}
                    text={actualTooltip}
                    data-testid={`${baseId}processing-icon`}
                />
            );
        case EMAIL_STATUSES.Red:
            return (
                <IconWithTooltip
                    icon={<IconStatusXCircleFill color="error" />}
                    text={actualTooltip}
                    data-testid={`${baseId}failed-icon`}
                />
            );
        case EMAIL_STATUSES.HollowRed:
            return (
                <IconWithTooltip
                    icon={<IconStatusXCircleRegular color="error" />}
                    text={actualTooltip}
                    data-testid={`${baseId}deferred-icon`}
                />
            );
        default:
            return (
                <IconWithTooltip
                    icon={<IconStatusQuestionFill color="warning" />}
                    text={actualTooltip}
                    data-testid={`${baseId}unknown-icon`}
                />
            );
    }
};
